
export default function ReasonsSection() {
  return (
    <section id="reasons" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            「ちょこっとハウス」が選ばれる<br />
            <span className="text-orange-500">3つの理由</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 理由1 */}
          <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-money-yen-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              建築コストが<br />かからない
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              ムダを省いたコンパクト設計だから、家づくりの費用も大きく抑えられます。
            </p>
            <div className="bg-white rounded-xl p-4">
              <p className="text-orange-600 font-bold text-lg">
                「1,000万円以下で建てたい」<br />
                という方も、ぜひご相談ください。
              </p>
            </div>
            <img 
              src="https://public.readdy.ai/ai/img_res/607a67996dbfe693dceda26a224c9d94.jpg"
              alt="建築コスト削減"
              className="w-full h-48 object-cover rounded-xl mt-6"
            />
          </div>

          {/* 理由2 */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-snowy-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              雪下ろしが<br />いらない
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              屋根形状や設計に工夫を凝らし、雪下ろしの負担を大幅軽減。
            </p>
            <div className="bg-white rounded-xl p-4">
              <p className="text-blue-600 font-bold text-lg">
                秋田の冬も、<br />
                安心して過ごせます。
              </p>
            </div>
            <img 
              src="https://readdy.ai/api/search-image?query=Snow-resistant%20Japanese%20house%20roof%20design%20in%20Akita%20winter%2C%20innovative%20roof%20structure%20that%20prevents%20snow%20accumulation%2C%20modern%20architectural%20solution%20for%20heavy%20snowfall%20areas%2C%20safe%20winter%20housing%20design%2C%20snow%20sliding%20off%20sloped%20roof%20naturally%2C%20peaceful%20snowy%20landscape&width=400&height=300&seq=snow-001&orientation=landscape"
              alt="雪下ろし不要の屋根設計"
              className="w-full h-48 object-cover rounded-xl mt-6"
            />
          </div>

          {/* 理由3 */}
          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              年齢を重ねた今こそ、<br />
              自分の家で安心を
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              「もうアパートには入りづらい」という声をたくさん聞きます。
            </p>
            <div className="bg-white rounded-xl p-4 space-y-2">
              <p className="text-green-600 font-bold">
                ✓ 自分の家なら、好きなように手入れできる
              </p>
              <p className="text-green-600 font-bold">
                ✓ 安心して、ずっと住み続けられる
              </p>
              <p className="text-green-600 font-bold">
                ✓ そんな"我が家"を手に入れませんか？
              </p>
            </div>
            <img 
              src="https://readdy.ai/api/search-image?query=Happy%20elderly%20Japanese%20couple%20in%20their%20cozy%20home%2C%20warm%20and%20comfortable%20living%20room%2C%20peaceful%20retirement%20lifestyle%2C%20senior-friendly%20house%20interior%20design%2C%20safety%20and%20comfort%20for%20aging%20in%20place%2C%20traditional%20Japanese%20home%20atmosphere%20with%20modern%20conveniences&width=400&height=300&seq=elderly-001&orientation=landscape"
              alt="安心の我が家"
              className="w-full h-48 object-cover rounded-xl mt-6"
            />
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 text-white">
            <h3 className="text-3xl font-bold mb-4">
              「ちょこっと」でいい、<br />
              いや「ちょこっと」がいい！
            </h3>
            <p className="text-xl mb-6">
              湯沢開発株式会社は、<br />
              秋田で暮らすお二人の「これから」を応援します。
            </p>
            <p className="text-lg">
              まずは、家づくりの疑問や不安、なんでもご相談ください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
